// planName: '',// 预案名称
//   planType: '',// 预案类型
//   planCategory: '',// 预案类别
//   street: '',
//   area: '',
//   administrativeDivision: '', // 行政区域
//   createUser: '',// 添加人
//   createDept: '',// 添加部门
//   isLive: false,// 是否现场指挥
//   planFilePath: {},// 预案附件
export const PreliminaryColumns = [
  { title: '预案名称', key: 'planName', align: 'center' },
  { title: '预案类型', key: 'planTypeName', align: 'center' },
  { title: '预案类别', key: 'planCategoryName', align: 'center' },
  // { title: '行政区域', key: 'administrativeDivisionName', align: 'center' },
  { title: '添加人', key: 'createUserName', align: 'center' },
  { title: '添加部门', key: 'createDeptName', align: 'center' },
  // {
  //   title: '是否现场指挥', key: 'isLive', align: 'center',
  //   render: (h, params) => {
  //     return h('span', {}, params.row.isLive ? '是' : '否')
  //   }
  // },
  { title: '操作', slot: 'action', align: 'center' }
]
